import { useEffect, useRef } from 'react';
import useNotify from '../../hooks/useNotify';
import {
  ALERT_CRITICAL_EVENT,
  NOTIFICATION_NEW_EVENT,
} from '../../services/socketService';
import {
  extractCriticalAlertInfo,
  formatCriticalAlertToast,
} from '../../utils/thresholdAlerts';

const TOAST_DEDUP_MS = 8000;

/**
 * App-wide listener: toast when backend emits Significant/critical threshold alerts.
 * Does not send Twilio/SendGrid — display only.
 */
export default function CriticalAlertToaster() {
  const { showToast } = useNotify();
  const recentRef = useRef(new Map());

  useEffect(() => {
    const onSocket = (event) => {
      const detail = event?.detail;
      if (!detail) return;

      const type = detail.type;
      if (type !== NOTIFICATION_NEW_EVENT && type !== ALERT_CRITICAL_EVENT) return;

      const info = extractCriticalAlertInfo(detail);
      if (!info) return;

      const now = Date.now();
      const last = recentRef.current.get(info.alertId);
      if (last != null && now - last < TOAST_DEDUP_MS) return;
      recentRef.current.set(info.alertId, now);

      // Prune old entries
      recentRef.current.forEach((ts, key) => {
        if (now - ts > TOAST_DEDUP_MS * 2) recentRef.current.delete(key);
      });

      showToast(formatCriticalAlertToast(info.bridgeName), 'warning');
    };

    window.addEventListener('shm:socket-event', onSocket);
    return () => window.removeEventListener('shm:socket-event', onSocket);
  }, [showToast]);

  return null;
}
